import { getCategory } from "../api"

export const state = {
    category: [],
    grade: [],
    difficulty: [],
}

export const getters = {
    category: state => state.category,
    grade: state => state.grade,
    difficulty: state => state.difficulty,
}


export const mutations = {
    setCategory(state, category) {
        state.category = category
    }
}
export const action = {
    async getCategory({ commit }) {
        let data = await getCategory();
        commit("setCategory", data);
    }
}